import { Text, Box, Center, GridItem, SimpleGrid, Spinner, VStack } from '@chakra-ui/react';
import ContainerBox from 'src/components/container-box/ContainerBox';
import TopBar from 'src/components/top-bar/TopBar';
import colors from 'src/theme/colors';
import { useNavigate } from 'react-router-dom';
import useGetUrlParam from 'src/hooks/useGetUrlParam';
import { Tier, useCreateSubscriptionFromSetupIntentMutation } from 'src/generated/graphql';
import { updateSubscriptionCache } from 'src/apollo/cache/update';
import { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { usePermissionsContext } from 'src/components/permissions/PermissionsContext';
import useApolloErrorHandler from 'src/hooks/useApolloErrorHandler';
import { Helmet } from 'react-helmet-async';
import ReviewsSection from './reviews/ReviewsSection';

export default function SignupProcessing() {
  const navigate = useNavigate();
  const client = useApolloClient();
  const [hasCalled, setHasCalled] = useState(false);

  const { permissions, refetchPermissions } = usePermissionsContext();

  useEffect(() => {
    if (permissions?.tier === Tier.Unlimited || permissions?.tier === Tier.Trial) {
      navigate('/personalise');
    }
  }, [navigate, permissions]);
  // use createSubscriptionFromSetupIntent mutation
  const [createSubscriptionFromSetupIntent, { called, error }] =
    useCreateSubscriptionFromSetupIntentMutation();

  const setupIntentClientSecret = useGetUrlParam('setup_intent_client_secret');
  const setupIntent = useGetUrlParam('setup_intent');

  useEffect(() => {
    if (hasCalled) return;
    setHasCalled(true);
    createSubscriptionFromSetupIntent({
      variables: {
        setupIntentId: setupIntent,
      },
    }).then(res => {
      const subscription = res.data?.createSubscriptionFromSetupIntent;
      if (subscription) {
        updateSubscriptionCache({ client, subscription });
        refetchPermissions();
      }
    });
  }, [
    called,
    client,
    createSubscriptionFromSetupIntent,
    hasCalled,
    navigate,
    refetchPermissions,
    setupIntent,
    setupIntentClientSecret,
  ]);

  useApolloErrorHandler(error);

  return (
    <Box pb="10px">
      <Helmet>
        <style>{`body { 
          background-color: ${colors.podcastShade100};
        }
   `}</style>
      </Helmet>
      <TopBar zIndex={4} />
      <SimpleGrid
        columns={{ sm: 2, md: 6, lg: 12 }}
        gapX={{ sm: 20, md: 30 }}
        rowGap={{ sm: '31px', md: '49px' }}
        maxW={{ md: 510, lg: 690, xl: 930, '2xl': 1110 }}
        minW="320px"
        mx="auto"
        mt={[0, '30px', null, '42px', '60px']}
        pb="46px"
      >
        <GridItem colSpan={[2, 6, 12, 8]}>
          <ContainerBox bgColor={colors.white} height="unset">
            <Center>
              <VStack gap="32px">
                <Text>We&apos;re just getting your Alitu account ready...</Text>
                <Spinner size="xl" />
              </VStack>
            </Center>
          </ContainerBox>
        </GridItem>
        <GridItem colSpan={[2, 4, 12, 4, 4]} colStart={[0, 2, 0, 0, 0]}>
          <ReviewsSection />
        </GridItem>
      </SimpleGrid>
    </Box>
  );
}
